export default "__VITE_ASSET__UNmRXVMA__"